import cn from 'clsx'

import { calcPnL } from '../../../../../OrderHistory/tables/OrderHistoryTable/utils/calcFunctions'

import s from './styles.module.scss'
import { getValueWithCurrency } from '@App/helpers/toCurrency'

export const ProfitAndLoss = ({
  quantity,
  open_rate,
  action_type,
  currentPrice,
  currency,
}: {
  quantity: number
  open_rate: number
  action_type: 'buy' | 'sell'
  currency: string
  currentPrice: number
}) => {
  const pnl = calcPnL(quantity, open_rate, currentPrice, action_type)
  return (
    <div className={s.container}>
      <div className={s.title}>Running P&L</div>
      <div className={cn(s.value, Number(pnl) < 0 ? s.negative : s.positive)}>
        {getValueWithCurrency(currency, Number(pnl))}
      </div>
    </div>
  )
}
